<script setup lang="ts">
    import type { LoadingSpinnerProps } from '@/types/components/loading';

    const props = withDefaults(defineProps<LoadingSpinnerProps>(), {
        width: 64,
        height: 64
    });
</script>

<template>
    <svg
        :width="props.width"
        :height="props.height"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="animate-spin"
    >
        <g clip-path="url(#clip0_2711_75154)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56Z"
                fill="#F7F7F7"
            />
            <path
                d="M64 32C64 14.3269 49.6731 0 32 0V8C45.2548 8 56 18.7452 56 32H64Z"
                fill="#191F45"
            />
        </g>
        <defs>
            <clipPath id="clip0_2711_75154">
                <rect width="64" height="64" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
